import { createContext, useContext } from 'react'

export const IsMobileHeaderRevealedContext = createContext<boolean>(false)
export const useIsMobileHeaderRevealed = (): boolean => useContext(IsMobileHeaderRevealedContext)

export const SetIsMobileHeaderRevealedContext = createContext<((isRevealed: boolean) => void) | null>(null)
export const useSetIsMobileHeaderRevealed = (): ((isRevealed: boolean) => void) => {
  const setter = useContext(SetIsMobileHeaderRevealedContext)

  if (setter === null) {
    throw new Error('useSetIsMobileHeaderRevealed was used outside of its provider.')
  }

  return setter
}
